module.exports = __webpack_public_path__ + "img/cancel.bdea0bed.svg";